module.exports = __webpack_public_path__ + "c6bd24f27cb187296c4f1c2f392866de.pdf";